import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Badge,
  Box,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import { useDispatch, useSelector } from "react-redux";
import { getProductCartApi } from "../redux/features/cart/getProductCartSlice";
import { loadCart } from "../redux/features/cart/getSessionCartSlice";

import Autocomplete from "@mui/material/Autocomplete";
import { getSpotGoldApi } from "../redux/features/spotGold/spotGoldSlice";
import { getGoldApi } from "../redux/features/goldSlice";

import { FaCartShopping } from "react-icons/fa6";
import ResponsiveNavbar from "./navbarMobile/ResponsiveNavbar";
import { resetProfile } from "../redux/features/profileSlice";
import { resetKycDetails } from "../redux/features/kycDetailsSlice";
import { Search } from "@mui/icons-material";
import { FaUserCircle } from "react-icons/fa";
import Swal from "sweetalert2";
import Loader from "./Loader";
import Loader2 from "./Loader2";
import axiosInstance from "../utils/axiosInstance";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const getSessionCartResponse = useSelector(
    (state) => state.getSessionCartSlice.data
  );

  // console.log("session cart==============", getSessionCartResponse);

  const addProductSliceResponse = useSelector(
    (state) => state.addProductCartSlice.data.data
  );

  // console.log(
  //   "add product SliceResponse=================",
  //   addProductSliceResponse
  // );

  const getCartSliceResponse = useSelector(
    (state) => state.getProductCartSlice.data.data
  );
  // console.log("DISHANT+==========++====", getCartSliceResponse?.data?.items?.length);

  const spotGoldSliceResponse = useSelector(
    (state) => state.spotGoldSlice.spotGold?.data?.data
  );

  // console.log("DISHANT SPOT GOLD API$$$$$$$$$$$$$$$",spotGoldSliceResponse)

  // const productNames = Array.isArray(spotGoldSliceResponse)
  //   ? spotGoldSliceResponse.map((item) => item.productName)
  //   : [];

  const productOptions = Array.isArray(spotGoldSliceResponse)
    ? spotGoldSliceResponse.map((item) => ({
        label: item.productName,
        id: item.id,
      }))
    : [];

  useEffect(() => {
    // dispatch(getProductCartApi());
  }, [dispatch, addProductSliceResponse?.totalAmount]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const Token = sessionStorage.getItem("token");

  const callLogoutAPI = async (e) => {
    e.preventDefault();

    // Show confirmation dialog first
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });

    // Proceed if user confirms
    if (result.isConfirmed) {
      try {
        // const url = `${process.env.REACT_APP_BASE_URL}/logout`;
        // const headers = {
        //   "Content-Type": "application/json",
        //   Accept: "application/json",
        //   Authorization: `Bearer ${Token}`,
        // };

        // const response = await fetch(url, {
        //   method: "POST",
        //   headers: headers,
        // });

        // const data = await response.json();

        const res = await axiosInstance.post("/logout");
        if (res.status === 200) {
          dispatch(resetProfile());
          dispatch(resetKycDetails());

          sessionStorage.clear();
          localStorage.clear();
          navigate("/login");
        }

        return res.data;
      } catch (error) {
        Swal.fire({
          title: "Logout failed",
          text: "An error occurred while logging you out.",
          icon: "error",
          confirmButtonColor: "#3085d6",
        });
        throw error;
      }
    }
  };

  // // Function to handle logout
  // const handleLogout = () => {
  //   socket.emit("user_logged_out", userId);
  //   console.log("User has been logged out.", userId);
  //   navigate("/");
  // };

  const handleYourAccount = () => {
    if (Token) {
      navigate("/account");
    } else {
      navigate("/login");
    }
  };

  const [cartCount, setCartCount] = useState("0");

  useEffect(() => {
    const count = Token
      ? getCartSliceResponse?.items?.length || 0
      : // : JSON.parse(sessionStorage.getItem("cart"))?.length || 0;
        getSessionCartResponse?.length || 0;
    setCartCount(count);
  }, [getCartSliceResponse, Token, cartCount, getSessionCartResponse]);

  const goldLivePrice = useSelector((state) => state.goldSlice.data.data);

  useEffect(() => {
    dispatch(getGoldApi());
  }, [dispatch]);

  const { gBuy, sBuy } = goldLivePrice?.[0]?.[0] || [];

  const handleSearchSubmit = (event) => {
    event.preventDefault();

    navigate("/shop/allProducts");
  };

  const [showHeader, setShowHeader] = useState(true);
  const lastScrollY = useRef(0); // useRef instead of state to avoid re-renders

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY.current) {
        // scrolling down → hide header
        setShowHeader(false);
      } else {
        // scrolling up → show header
        setShowHeader(true);
      }
      lastScrollY.current = window.scrollY; // update ref
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // empty dependency → listener registered once

  // =====================================

  // let lastScrollTop = 0;
  // const header = document.querySelector("header");

  // window.addEventListener("scroll", () => {
  //   let scrollTop = window.scrollY || document.documentElement.scrollTop;

  //   // Prevent negative scroll values (iOS bounce effect)
  //   if (scrollTop < 0) scrollTop = 0;

  //   if (scrollTop > lastScrollTop) {
  //     // scrolling down → hide header
  //     header.classList.add("hide");
  //     header.classList.remove("show");
  //   } else {
  //     // scrolling up → show header
  //     header.classList.add("show");
  //     header.classList.remove("hide");
  //   }

  //   lastScrollTop = scrollTop;
  // });

  return (
    <div
      className={`scroll_header ${showHeader ? "visible" : "hidden_header"}`}
    >
      <div className="navbar_main">
        <div className="nav_sec1">
          <nav className="navbar-container">
            <div>
              <Link to="/">
                <img
                  // src="/images/BajajLogo.png"
                  src="/images/tigerfintech-logo.png"
                  alt="Bajaj_logo"
                  className="nav_main_logo"
                />
              </Link>
            </div>
            {/* NAV LINKS========== */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "2.625rem",
              }}
            >
              {/* <div className="nav_links_container">
                <Link
                  to="/"
                  className={`link ${
                    location.pathname === "/" ? "active" : ""
                  }`}
                >
                  HOME
                </Link>
              </div> */}
              {/* NAV SEARCHBAR======== */}
              {location.pathname.includes("shop") && (
                <form className="nav-searchbar" onSubmit={handleSearchSubmit}>
                  <Autocomplete
                    id="free-solo-demo"
                    size="small"
                    fullWidth
                    freeSolo
                    options={productOptions}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, value) => {
                      if (value && value.id) {
                        // Ensure there's a valid option selected before navigating
                        navigate(`/shop/${value.id}`);
                      }
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.label}
                        {"   "}
                        {option.id}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        placeholder="Search for Gold Jewellery, Diamond and more..."
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search style={{ color: "gray" }} />{" "}
                              {/* Search icon */}
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />

                  {/* <Button
                type="submit"
                sx={{
                  backgroundColor: "#c62128",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#c62128",
                  },
                }}
              >
                <FaSearch size={25} color="#472878" />
              </Button> */}
                </form>
              )}
              {/* NAV BUTTONS=== */}
              <div>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  {(location.pathname.includes("shop") ||
                    location.pathname.includes("category") ||
                    location.pathname.includes("cart")) && (
                    <Link to="/shop/cart">
                      <Tooltip title="Cart">
                        <IconButton
                          size="small"
                          sx={{ ml: 1 }}
                          aria-controls={open ? "account-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                        >
                          <div
                            style={{
                              padding: "5px",
                              backgroundColor: "#c62128",
                              borderRadius: "50%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Badge badgeContent={cartCount} color="secondary">
                              <FaCartShopping size={25} color="#fff" />
                            </Badge>
                          </div>
                        </IconButton>
                      </Tooltip>
                    </Link>
                  )}

                  {Token ? (
                    <Tooltip title="Account settings">
                      <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 1 }}
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                      >
                        <FaUserCircle size={35} color="#c62128" />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <>
                      <button
                        onClick={() => navigate("/login")}
                        style={{
                          padding: "0.5rem 2rem",
                          border: "2px solid #DA2128",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          color: "#C62128",
                          fontSize: "0.9rem",
                          fontWeight: "600",
                        }}
                        // className="login_btn"
                      >
                        Login
                      </button>
                    </>
                  )}

                  {/* <ResponsiveNavbar /> */}
                </Box>

                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  onClick={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <div>
                    {/* <MenuItem onClick={handleYourAccount}>
                      <Avatar /> Your Account
                    </MenuItem> */}
                    <MenuItem onClick={callLogoutAPI}>
                      <ListItemIcon>
                        <Logout fontSize="small" />
                      </ListItemIcon>
                      Logout
                    </MenuItem>
                  </div>
                </Menu>
              </div>
            </div>
          </nav>
        </div>
        {/* =================================LIVE PRICES============================== */}
        <div className="live_price_main">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5rem",
              fontWeight: "500",
              color: "#7A7474",
            }}
          >
            Gold Price
            <span style={{ color: "#383434", fontWeight: "700" }}>
              {gBuy && gBuy}/gm
            </span>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
                color: " #DA2128",
              }}
            >
              <div className="notification-dot"></div>
              Live
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5rem",
              fontWeight: "500",
              color: "#7A7474",
            }}
          >
            Silver Price
            <span style={{ color: "#383434", fontWeight: "700" }}>
              {sBuy && sBuy}/gm
            </span>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
                color: " #DA2128",
              }}
            >
              <div className="notification-dot"></div>
              Live
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
